"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var XIcon16Light_1 = require("./icons/XIcon/XIcon16Light");
Object.defineProperty(exports, "XIcon16Light", { enumerable: true, get: function () { return XIcon16Light_1.XIcon16Light; } });
